import React from 'react';

export default function Scheduling() {
  return (
    <main className="bg-gray-50 py-16">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Page Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900">Schedule a Meeting</h1>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
            Feel free to book a time that works for you using the interactive calendar below. The tool is connected directly to my Google Calendar.
          </p>
        </div>

        {/* Google Calendar Embed Section */}
        <div className="bg-white rounded-lg shadow-lg overflow-hidden min-h-[600px] p-2">
          <div className="flex items-center justify-center h-full bg-gray-100 rounded-md">
            <iframe
              src="https://calendar.google.com/calendar/appointments/AcZssZ2B8ACqBu9hHObIQgElKmxKIEWlZYP0TQ1O39Q=?gv=true"
              style={{ border: 0 }}
              width="100%"
              height="850"
              title="Google Calendar Appointment Scheduling"
              frameBorder="0"
            />
          </div>
        </div>
      </div>
    </main>
  );
}
